import React, { useState } from "react";
import { usePasswordValidation } from "../../../Logic/Functions/Hooks/usePasswordValidation";
import { IPasswordInputProps } from "../../../Model/UIComponents.model";
import HidePassword from "Utils/Assets/SVGs/HidePassword";
import ShowPassword from "Utils/Assets/SVGs/ShowPassword";
import styles from './UiLibraryComponent.module.css';

const PasswordInput: React.FC<IPasswordInputProps> = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  customContainerStyle = "",
  customErrorStyle = "",
  rules = [],
}) => {
  const [hidePassword, setHidePassword] = useState(true);
  const { results } = usePasswordValidation({ value, rules });

  const switchVisibility = () => setHidePassword((prev) => !prev);

  return (
    <div className={styles.inputContainer}>
      <label
        className={styles.inputLabel}
        data-testid="custom_password_input_label"
      > {label}</label>

      <div
        className={`${styles.passwordInputContainer} ${
          error ? styles.inputWithError : ""
        } ${customContainerStyle}`}
        data-testid="custom_password_input_container"
      >
        <input
          type={hidePassword ? "password" : "text"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={styles.passwordInput}
          data-testid="custom_password_input_field"
        />
        <button
          type="button"
          onClick={switchVisibility}
          className={styles.passwordVisibilityButton}
          data-testid="custom_password_input_toggle"
        >
          {hidePassword ? (
            <HidePassword width={20} height={20} />
          ) : (
            <ShowPassword width={20} height={20} />
          )}
        </button>
      </div>

      {error && (
        <div
          className={`${styles.errorMessage} ${customErrorStyle}`}
          data-testid="custom_password_input_error"
        >
          {error}
        </div>
      )}

      <div
        className={styles.passwordRulesContainer}
        data-testid="custom_password_input_rules"
      >
        {results.map((result, index) => (
          <span
            key={index}
          className={`${styles.passwordRule} ${result.isValid ? styles.passwordRule_completed : ""}`}

            data-testid={`custom_password_rule_${index}`}
          >
            {result.message}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PasswordInput;
